import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createTaxGroupRequest = { taxGroup: '_taxGroup' };
var _createTaxGroupResponse = { taxGroup: '_taxGroup' };
var _deleteTaxGroupRequest = {};
var _deleteTaxGroupResponse = {};
var _getTaxGroupRequest = {};
var _getTaxGroupResponse = { taxGroup: '_taxGroup' };
var _listDefaultTaxGroupsByAppIdsRequest = {};
var _listDefaultTaxGroupsByAppIdsResponse = {
    results: '_listDefaultTaxGroupsByAppIdsResult',
};
var _listDefaultTaxGroupsByAppIdsResult = { taxGroup: '_taxGroup' };
var _listDefaultTaxGroupsRequest = {};
var _listDefaultTaxGroupsResponse = { taxGroups: '_taxGroup' };
var _queryTaxGroupsRequest = {};
var _queryTaxGroupsResponse = { taxGroups: '_taxGroup' };
var _taxGroup = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateTaxGroupRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    taxGroup: '_taxGroup',
};
var _updateTaxGroupResponse = { taxGroup: '_taxGroup' };
function resolveWixBillingV1TaxGroupsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/billing/v1/tax-groups',
                destPath: '/v1/tax-groups',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/billing/v1/tax-groups',
                destPath: '/v1/tax-groups',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a tax group.
 *
 * Call Stores Update Product to add the `taxGroupId` to specific products to categorize as a group based on distinct tax treatment.
 * Wix uses tax groups to calculate tax.
 *
 * In addition to tax groups you create, default tax groups are already included in all Wix catalogs.
 * Call List Default Tax Groups to retrieve them. You can also use the Tax Groups Integration service plugin (REST only)
 * to create new default tax groups that can be applied directly to an entire catalog of products.
 */
export function createTaxGroup(payload) {
    var _a = serializer(_createTaxGroupRequest, { _taxGroup: _taxGroup }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTaxGroupResponse, {
        _taxGroup: _taxGroup,
    }).fromJSON;
    function __createTaxGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_group',
            method: 'POST',
            methodFqn: 'wix.billing.v1.TaxGroups.CreateTaxGroup',
            url: resolveWixBillingV1TaxGroupsUrl({
                protoPath: '/v1/tax-groups',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTaxGroup.fromReq = fromReq;
    __createTaxGroup.__isAmbassador = true;
    return __createTaxGroup;
}
/** Retrieves a tax group. */
export function getTaxGroup(payload) {
    var _a = serializer(_getTaxGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTaxGroupResponse, { _taxGroup: _taxGroup }).fromJSON;
    function __getTaxGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_group',
            method: 'GET',
            methodFqn: 'wix.billing.v1.TaxGroups.GetTaxGroup',
            url: resolveWixBillingV1TaxGroupsUrl({
                protoPath: '/v1/tax-groups/{taxGroupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTaxGroup.fromReq = fromReq;
    __getTaxGroup.__isAmbassador = true;
    return __getTaxGroup;
}
/**
 * Updates a tax group.
 *
 * Each time the tax group is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating the tax group.
 * This ensures you're working with the latest tax group and prevents
 * unintended overwrites.
 */
export function updateTaxGroup(payload) {
    var _a = serializer(_updateTaxGroupRequest, { _taxGroup: _taxGroup }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTaxGroupResponse, {
        _taxGroup: _taxGroup,
    }).fromJSON;
    function __updateTaxGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_group',
            method: 'PATCH',
            methodFqn: 'wix.billing.v1.TaxGroups.UpdateTaxGroup',
            url: resolveWixBillingV1TaxGroupsUrl({
                protoPath: '/v1/tax-groups/{taxGroup.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTaxGroup.fromReq = fromReq;
    __updateTaxGroup.__isAmbassador = true;
    return __updateTaxGroup;
}
/**
 * Deletes a tax group.
 *
 * If a tax group is deleted but the `taxGroupId` is still assigned to a product (see Stores Products API) then the default tax group is used to calculate tax.
 */
export function deleteTaxGroup(payload) {
    var _a = serializer(_deleteTaxGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTaxGroupResponse, {}).fromJSON;
    function __deleteTaxGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_group',
            method: 'DELETE',
            methodFqn: 'wix.billing.v1.TaxGroups.DeleteTaxGroup',
            url: resolveWixBillingV1TaxGroupsUrl({
                protoPath: '/v1/tax-groups/{taxGroupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTaxGroup.fromReq = fromReq;
    __deleteTaxGroup.__isAmbassador = true;
    return __deleteTaxGroup;
}
/**
 * Retrieves a list of tax groups, given the provided paging, filtering, and sorting.
 *
 * Only tax groups that were created by this site will be retrieved with this query. Use [List Default Tax Groups](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-groups/list-default-tax-groups)
 * or [List Default Tax Groups By App ID](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-groups/list-default-tax-groups-by-app-ids)
 * to retrieve a site's default tax groups.
 *
 * For field support for filters and sorting, see [Tax Groups: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-groups/supported-filters-and-sorting).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryTaxGroups(payload) {
    var _a = serializer(_queryTaxGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryTaxGroupsResponse, {
        _taxGroup: _taxGroup,
    }).fromJSON;
    function __queryTaxGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_group',
            method: 'POST',
            methodFqn: 'wix.billing.v1.TaxGroups.QueryTaxGroups',
            url: resolveWixBillingV1TaxGroupsUrl({
                protoPath: '/v1/tax-groups/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryTaxGroups.fromReq = fromReq;
    __queryTaxGroups.__isAmbassador = true;
    return __queryTaxGroups;
}
/**
 * Retrieves a list of default tax groups.
 *
 * The default tax groups for a site are inherited by the apps installed on the site.
 * For example, the Wix Stores app includes a `"Products"` tax group by default.
 *
 * Add additional default tax groups with the Tax Groups Integration service plugin (REST only).
 */
export function listDefaultTaxGroups(payload) {
    var _a = serializer(_listDefaultTaxGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDefaultTaxGroupsResponse, {
        _taxGroup: _taxGroup,
    }).fromJSON;
    function __listDefaultTaxGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_group',
            method: 'GET',
            methodFqn: 'wix.billing.v1.TaxGroups.ListDefaultTaxGroups',
            url: resolveWixBillingV1TaxGroupsUrl({
                protoPath: '/v1/tax-groups/default-tax-groups',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDefaultTaxGroups.fromReq = fromReq;
    __listDefaultTaxGroups.__isAmbassador = true;
    return __listDefaultTaxGroups;
}
/** Retrieves default tax groups for specific apps. */
export function listDefaultTaxGroupsByAppIds(payload) {
    var _a = serializer(_listDefaultTaxGroupsByAppIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDefaultTaxGroupsByAppIdsResponse, { _listDefaultTaxGroupsByAppIdsResult: _listDefaultTaxGroupsByAppIdsResult, _taxGroup: _taxGroup }).fromJSON;
    function __listDefaultTaxGroupsByAppIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.billing.v1.tax_group',
            method: 'POST',
            methodFqn: 'wix.billing.v1.TaxGroups.ListDefaultTaxGroupsByAppIds',
            url: resolveWixBillingV1TaxGroupsUrl({
                protoPath: '/v1/tax-groups/list-default-tax-groups-by-app-ids',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDefaultTaxGroupsByAppIds.fromReq = fromReq;
    __listDefaultTaxGroupsByAppIds.__isAmbassador = true;
    return __listDefaultTaxGroupsByAppIds;
}
//# sourceMappingURL=http.impl.js.map